module.exports = __webpack_public_path__ + "static/img/ejkloginBG-2.6127242.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ejkloginBG-2.png
// module id = 3112
// module chunks = 1